<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <!-- 仅有一个可显示的子路由,并且没有孙子路由 && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && item.alwaysShow-->
    <template v-if="hasOneShowingChild(item.children,item)">
      <router-link v-if="onlyOneChild.meta && !onlyOneChild.meta.hidden"
                   :to="getPath(onlyOneChild)">
        <el-menu-item
          :index="resolvePath((item.name+'').indexOf('?')>=0?onlyOneChild.name+'&menuname='+item.meta.title:onlyOneChild.name)"
          :class="{'submenu-title-noDropdown' : isNest }">
          <item :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" :title="onlyOneChild.meta.title"/>
        </el-menu-item>
      </router-link>
    </template>
    <el-submenu v-else ref="subMenu"
                :index="resolvePath((item.name+'').indexOf('?')>=0?onlyOneChild.name+'&menuname='+item.meta.title:onlyOneChild.name)"
                popper-append-to-body>
      <template v-slot:title>
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title"/>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.name"
        :is-nest='true'
        :item='child'
        :base-path="resolvePath(child.name)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
  import path from 'path'
  import Item from './Item'

  export default {
    name: "SidebarItem",
    components: {Item},
    props: {
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        required: false
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data () {
      this.onlyOneChild = null
      return {}
    },
    methods: {
      /*是否在侧边栏隐藏*/
      hasOneShowingChild (children = [], parent) {

        const showingChildren = children.filter(item => {
          if (item.hidden) {
            return false
          } else {
            // 如果只有一个子菜单时设置
            this.onlyOneChild = item
            return true
          }
        })

        // 当只有一个子路由,子路由默认展示
        // if(showingChildren.length === 1){
        //     return true
        // }
        // 没有子路由则显示父路由
        if (showingChildren.length === 0) {
          this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
          return true
        }
        return false
      },
      resolvePath (routePath) {
        return path.resolve(this.basePath, routePath)
      },
      getPath (routePath) {
        let paths = this.resolvePath(routePath.path.split("?")[0]);

        let para = {};
        if (routePath.name.indexOf('?') >= 0) {
          let arr = routePath.name.split('?');
          if (arr.length > 1) {
            let paraArr = arr[1].split('&');
            paraArr.forEach(item => {
              // console.log(item)
              let newArr = item.split('=');
              for (let i = 0; i < newArr.length; i++) {
                let name = newArr[0];
                let paras = newArr[1];
                para[name] = paras;
              }
            });
          }
          para["menuname"] = routePath.title;
          para["ruleId"] = routePath.id;
        }
        if (routePath.name.indexOf('?') >= 0) {
          return {path: paths, query: para}
        } else {
          return {path: paths}
        }
      }
    }
  }
</script>

<style>
  .menu-wrapper>a{
    text-decoration: none;
  }
  .menu-wrapper .el-submenu [class^=icon-] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > a > .el-menu-item.is-active,
  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu:hover {
    background: #fff !important;
    color: #1A86EE !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu:hover {
    background: #fff !important;
    color: #1A86EE !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu:hover {
    background: transparent !important;
    color: #1A86EE !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu {
    background: transparent !important;

  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-submenu__title {
    padding-left: 0 !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > ul > li.is-active {
    background: #fff !important;
    color: #1A86EE !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > a > .el-menu-item:hover,
  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-submenu__title:hover {
    background: transparent !important;
    color: #1A86EE !important;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > a > .el-menu-item:first-child,
  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-submenu__title:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > a > .el-menu-item:last-child,
  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-submenu__title:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .menu-wrapper .el-submenu .el-menu-item.is-active {
    position: relative;
  }

  .menu-wrapper.nest-menu .menu-wrapper.nest-menu .el-menu-item.is-active::after {
    content: '';
    width: 3px;
    height: 16px;
    background-color: #1A86EE;
    position: absolute;
    right: 0;
    top: 18px;

  }

  .menu-wrapper .el-submenu .el-menu-item {
    padding: 0;
    color: #333 !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    min-width: 0 !important;
  }

  .menu-wrapper .el-submenu .el-menu-item i {
    color: #1A86EE !important;
  }

  .menu-wrapper .el-submenu .el-menu {
    margin: 20px;
    border-radius: 10px;
    background-color: #f2f8fe !important;

  }

  .menu-wrapper .el-submenu .el-menu .menu-wrapper.nest-menu .menu-wrapper.nest-menu .el-menu:hover {
    background-color: transparent !important;
  }

  .menu-wrapper .el-submenu .el-submenu__title i {
    color: #fff;
  }

  .menu-wrapper .el-submenu .el-submenu__title:hover {
    background-color: #5c8fea !important;
  }

  .menu-wrapper .el-submenu .el-submenu__title, .menu-wrapper .el-submenu .el-submenu__title i {
    color: #ffffff8c !important;
  }

  .menu-wrapper .el-submenu.is-opened .el-submenu__title, .menu-wrapper .el-submenu.is-opened .el-submenu__title i {
    color: #fff !important;
  }

  .menu-wrapper.nest-menu .el-submenu .el-menu {
    margin: 15px;
  }

  .menu-wrapper.nest-menu .el-submenu .el-menu-item {
    padding: 0 !important;
  }

  .menu-wrapper.nest-menu .el-submenu .el-submenu__title {
    padding-left: 10px !important;
    color: #333 !important;
  }

  .is-opened .menu-wrapper.nest-menu .el-submenu .el-submenu__title > i {
    color: #5c8fea !important;
  }

  .menu-wrapper.nest-menu .el-submenu .el-menu .menu-wrapper.nest-menu .submenu-title-noDropdown i:before,
  .menu-wrapper > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-menu > .menu-wrapper.nest-menu > .el-submenu > .el-submenu__title ~ i::before {
    content: '\2022';
  }


</style>
